import {Injectable} from '@angular/core';
import {LorenBaseEndpointsService} from '../../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service';

@Injectable({
    providedIn: 'root'
})
export class LorenGeofencingEndpointsService extends LorenBaseEndpointsService {

    constructor() {
        super();
    }

    geoFenceZonesCircles() {
        return `${this.getApiServerUrl()}/geofence-zones/circles`;
    }

    geoFenceZonesPolygons() {
        return `${this.getApiServerUrl()}/geofence-zones/polygons`;
    }
}
